import { useState } from "react";
import close from "../../images/close.svg";
import bell from "../../images/bell-outline-on.svg";
import { FaChevronUp } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
import unviewedNotif from "../../images/unviewed-notif.svg";
import viewedNotif from "../../images/viewed-notif.svg";

const AdminNotificationPanel = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [casesOpen, setCasesOpen] = useState(true);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleToggleShowCases = () => {
    setCasesOpen((prev) => !prev);
  };

  const mockData = [
    { reportId: 54786, viewed: false },
    { reportId: 54786, viewed: false },
    { reportId: 54786, viewed: true },
    { reportId: 54786, viewed: false },
  ];

  return (
    <>
      <img
        src={bell}
        alt=""
        onClick={toggleMenu}
        className={`cursor-pointer ${menuOpen ? "hidden" : "block"}`}
      />

      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40"
          onClick={toggleMenu}
        />
      )}

      {/* Sliding Side Menu */}
      <div
        className={`flex flex-col justify-between fixed left-0 top-0 h-full w-[300px] xs:w-[400px] p-10 pt-[102px] bg-white text-black transform transition-transform duration-700 z-50 ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <button
          className="w-[30px] h-[30px] flex justify-center items-center absolute top-10 right-10 focus:outline-none"
          onClick={toggleMenu}
        >
          <img src={close} alt="close" />
        </button>

        <div className="flex flex-col gap-[32px] text-gray-7">
          <h1 className="font-[800] text-[26px] leading-[32px]">
            Notifications
          </h1>

          <div className="flex flex-col gap-[24px]">
            <h4
              className="font-[600] text-[20px] leading-[24px] flex items-center gap-[14px] cursor-pointer"
              onClick={handleToggleShowCases}
            >
              Repeat Cases ({3})
              {casesOpen ? (
                <FaChevronUp className="text-[12px]" />
              ) : (
                <FaChevronDown className="text-[12px]" />
              )}
            </h4>

            {casesOpen && (
              <div className="flex flex-col gap-2">
                {mockData.map(({ reportId, viewed }, i) => (
                  <div
                    key={i}
                    className={`flex items-start gap-[13.78px] p-[10px] cursor-pointer ${
                      viewed ? "bg-white" : "bg-gray-1 rounded-[8px]"
                    }`}
                  >
                    <img src={viewed ? viewedNotif : unviewedNotif} alt="" />
                    <p className="font-[400] text-[12px] leading-[14px] text-gray-7">
                      The status of case{" "}
                      <span className="font-[600] text-[14px] leading-4">
                        N°{reportId}
                      </span>{" "}
                      changed from reviewed to not reviewed
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminNotificationPanel;
